import React, { createContext, useState, useContext, useEffect } from 'react';
import { translations } from '../data/translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('et'); // Default to Estonian

  useEffect(() => {
    // Check URL path for language
    const path = window.location.pathname;
    if (path.startsWith('/en')) {
      setLanguage('en');
    } else {
      setLanguage('et');
    }
  }, []);

  const t = translations[language];

  const changeLanguage = (lang) => {
    setLanguage(lang);
    // Update URL
    if (lang === 'en') {
      window.history.pushState({}, '', '/en');
    } else {
      window.history.pushState({}, '', '/');
    }
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
